import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { Reveal } from './Reveal';
export function Navbar() {
  const links = ['main', 'tiers', 'features', 'talk to us'];
  return <>
      <div className="fixed left-5 top-5 z-50 sm:left-8 sm:top-7 md:left-12" data-id="element-1578">
        <Reveal data-id="element-1579">
          <a href="#" className="font-mono text-lg font-medium tracking-tight text-white drop-shadow-md sm:text-xl md:text-2xl" data-id="element-1580">
            (NOVA_AI)
          </a>
        </Reveal>
        <Reveal delay={150} data-id="element-1581">
          <div className="mt-6 font-mono text-[10px] text-white/60 sm:mt-8 sm:text-xs" data-id="element-1582">
            [ v.01b ]
          </div>
        </Reveal>
      </div>

      <nav className="fixed right-5 top-5 z-50 sm:right-8 sm:top-7 md:right-12" data-id="element-1583">
        <ul className="flex flex-col items-end gap-1.5 sm:gap-2" data-id="element-1584">
          {links.map((link, i) => <li key={link} data-id="element-1585">
              <Reveal delay={100 + i * 120} data-id="element-1586">
                <a href="#" className="group flex items-center gap-1 font-mono text-xs text-white/80 drop-shadow-md transition-colors duration-300 hover:text-white sm:text-sm" data-id="element-1587">
                  {link}
                  <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" data-id="element-1588" />
                </a>
              </Reveal>
            </li>)}
        </ul>
      </nav>
    </>;
}